// If the environment provides Pendo then it will provide
// the basic methods immediately from html and the advanced methods
// after loading the js without a rerender. If the environment does not have Pendo
// then no methods are defined ever

type Pendo = pendo.Pendo;

export function usePendo(): Pendo | null {
  // oxlint-disable-next-line unicorn/prefer-global-this
  const { pendo } = window;
  if (typeof pendo === "undefined") {
    return null;
  }
  return pendo;
}
